<template>
	<div class="table flex-column">
		<div v-if="thead" class="thead flex">
			<div v-for="(item, i) in fieldList" :key="i" :style="{'flex-grow': item.width}">{{item.name}}</div>
		</div>
		<div class="tbody flex-grow">
			<c-scroll ref="scroll" bar-color="rgba(255,255,255,.3)" @scroll="scrollHandle">
				<div v-for="(data, i) in dataList" :key="i" class="tr flex">
					<div v-for="(item, j) in fieldList" :key="j" class="flex-center-cross" :style="{'flex-grow': item.width}">
						<slot v-if="$scopedSlots[item.code]" :name="item.code" :data="data"></slot>
						<span v-else>{{data[item.code]}}</span>
					</div>
				</div>
				<c-empty v-show="emptyState"></c-empty>
			</c-scroll>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				thead: false,
				fieldList: [],
				dataList: [],
				emptyState: false
			}
		},

		methods: {
			init(data) {
				this.thead = data.thead === false ? false : true;
				this.fieldList = data.fieldList;
			},

			update(data) {
				this.emptyState = !data.length;
				this.dataList = data;
			},

			scrollHandle(e) {
				console.log(e)
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.table {
		height: 100%;

		.thead {
			margin-bottom: .06rem;

			div {
				width: 0;
				padding: 0 .1rem;
				line-height: .4rem;
				font-size: .14rem;
				white-space: nowrap;
				color: #00FFFF;
				background: #092341;

				&:nth-child(n+2) {
					margin-left: .03rem;
				}
			}
		}

		.tbody {
			.tr {
				background: #092341;

				&:nth-child(n+2) {
					margin-top: .04rem;
				}

				> div {
					width: 0;
					min-height: .4rem;
					padding: 0 .1rem;
					font-size: .14rem;
					color: #fff;

					&:nth-child(n+2) {
						margin-left: .03rem;
					}
				}
			}
		}
	}
</style>
